<script lang="ts">
  export let percentage = 0;

  let realPercent = 0;

  $: {
    realPercent = percentage < 100 ? percentage : 100;
  }
</script>

<div class="progress-wrapper">
  <div class="progress-inner">
    <div class="progress-portion" style:width={`${realPercent}%`} />
  </div>
  <div class="progress-text">
    领取中: {realPercent}%
  </div>
</div>

<style lang="scss">
  .progress-wrapper {
    text-align: center;
    .progress-inner {
      height: 6px;
      background: #f5f5f5;
      border-radius: 8px;
      border-radius: 3px;
      width: 100%;
      position: relative;
      .progress-portion {
        position: absolute;
        left: 0;
        border-radius: 8px;
        border-radius: 3px;
        background: #ffdc14;
        height: 6px;
      }
    }
    .progress-text {
      margin-top: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(25, 25, 25, 0.5);
    }
  }
</style>
